import { v4 as uuidv4 } from 'uuid';

export const linkClasses =
  'no-underline font-medium bg-primary/10 text-primary';
export const replaceAllLinks = (props: { title: string; href: string }) => {
  const { title, href } = props;
  const id = uuidv4();
  return `
		<a href="${href}" class="${linkClasses}">
			<span class="underline">${title}</span>
		</a>
		`;
};
export const replaceExternalLinks = (props: { title: string; href: string }) => {
  const { title, href } = props;
  const id = uuidv4();
  return `
		<a href="${href}" class="${linkClasses}" target="_blank" rel="noopener">
			<span class="underline">${title}</span>
			<span class="w-4 h4 inline-block ml-1 -top-0.5 align-middle relative" aria-hidden="true">
				<svg fill="none" stroke="currentcolor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 16 16" role="img" aria-labelledby="${id}" xmlns="http://www.w3.org/2000/svg"><title id="${id}">External link icon</title><path d="M6.75 1.75h-5v12.5h12.5v-5m0-4v-3.5h-3.5M8 8l5.5-5.5"></path></svg>
				</span>
		</a>
		`;
};

export const findReplaceLinksInText = (text: string) => {
  return text.replace(
    /<a\s+(?:[^>]*?\s+)?href=["']([^"']*)["'][^>]*?>(.+?)<\/a>/gi,
    (match, url, text) => {
      if (url.startsWith('/')) {
        return replaceAllLinks({ title: text, href: url });
      } else {
        return replaceExternalLinks({ title: text, href: url });
      }
    }
  );
  // return text
  //   .replace(/<a\s+(?:[^>]*?\s+)?href=["'](\/.*)["']>([^<]+)<\/a>/gi, (match, url, text) => {
  //     return replaceAllLinks({
  //       title: text,
  //       href: url
  //     });
  //   })
  //   .replace(/<a href="(https?:)\/\/(.*)">([^<]+)<\/a>/gi, (match, protocol, domain, text) => {
  //     return replaceExternalLinks({
  //       title: text,
  //       href: `https://${domain}`
  //     });
  //   });
};
